export const newsList = [
  {
    id: "news-001",
    title: "《火影忍者》动画迎来开播周年纪念，官方推出全新视觉企划",
    date: "2026-10-12",
    category: "官方动态",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20anniversary%20key%20visual%20of%20a%20ninja%20village%20festival%20with%20lanterns%20and%20banners%2C%20festive%20warm%20orange%20and%20cream%20tones%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20vibrant%20colors&width=900&height=560&seq=news-001-cover&orientation=landscape",
    summary:
      "为纪念动画开播，官方公开了一组全新视觉企划与合作周边信息，涵盖角色立绘、纪念海报与限定展区。",
    content: [
      "为纪念《火影忍者》动画开播周年，官方近日公开了一组全新视觉企划，主角群以经典造型重新演绎，向系列一路走来的旅程致敬。",
      "本次企划包含角色立绘海报、纪念展区以及多款限定周边，官方表示希望以「羁绊」为主题，让粉丝重温忍者世界带来的感动。",
      "此外，官方同步更新了主题活动日程，将陆续公开更多角色相关内容，动漫频道会持续跟进报道，欢迎关注后续更新。",
    ],
  },
  {
    id: "news-002",
    title: "角色人气票选结果公布，鸣人与佐助稳居前列",
    date: "2026-10-08",
    category: "粉丝活动",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20large%20popularity%20poll%20board%20with%20portraits%20of%20various%20ninja%20characters%20and%20ranking%20numbers%2C%20cheerful%20bright%20colors%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=news-002-cover&orientation=landscape",
    summary:
      "最新一轮全球角色人气票选结果出炉，鸣人与佐助再度占据前列，卡卡西与鼬紧随其后。",
    content: [
      "最新一轮全球角色人气票选正式公布结果，漩涡鸣人与宇智波佐助凭借深厚的人气基础稳居前列，成为粉丝心中最具代表性的角色。",
      "旗木卡卡西与宇智波鼬分列其后，不少粉丝留言表示，正是这些角色的成长与抉择让整部作品拥有了超越时代的感染力。",
      "主办方表示，票选结果也将作为后续周边与企划的参考，动漫频道将持续整理各角色的人气与资料，方便粉丝查阅。",
    ],
  },
  {
    id: "news-003",
    title: "经典剧情重温特辑上线，聚焦终结之谷对决",
    date: "2026-10-03",
    category: "剧情解析",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20two%20ninja%20silhouettes%20facing%20each%20other%20by%20a%20waterfall%20at%20dusk%2C%20dramatic%20dark%20and%20orange%20sky%2C%20emotional%20cinematic%20mood%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=news-003-cover&orientation=landscape",
    summary:
      "本站推出经典剧情重温特辑，首期聚焦终结之谷对决，梳理鸣人与佐助羁绊的关键转折。",
    content: [
      "本站近期推出「经典剧情重温」特辑，首期内容聚焦终结之谷中鸣人与佐助的宿命对决，梳理这场战斗背后的情感与选择。",
      "特辑从两人童年经历、各自忍道与关键时刻的抉择出发，帮助新老观众更完整地理解这段羁绊的分量。",
      "后续特辑还将覆盖中忍考试、木叶崩溃等经典篇章，欢迎在剧集列表中配合剧情介绍一同阅读。",
    ],
  },
  {
    id: "news-004",
    title: "限定周边发售预告，写轮眼主题系列即将登场",
    date: "2026-09-27",
    category: "周边情报",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20merchandise%20flat%20lay%20of%20notebooks%20badges%20and%20keychains%20with%20red%20eye%20spiral%20patterns%2C%20clean%20warm%20beige%20background%2C%20product%20photography%20style%2C%20high%20detail%2C%20organized%20composition&width=900&height=560&seq=news-004-cover&orientation=landscape",
    summary:
      "以写轮眼为主题的限定周边系列即将发售，涵盖徽章、钥匙扣与文具等多款单品。",
    content: [
      "官方公开了以写轮眼为主题的限定周边系列预告，涵盖徽章、钥匙扣、笔记本等多款单品，图案设计以经典瞳术纹样为核心。",
      "该系列预计在近期正式发售，部分单品为限量发行，粉丝可关注官方渠道获取具体的上架时间与购买方式。",
      "动漫频道提醒，购买周边时请以官方公布的渠道为准，理性消费，享受收藏的乐趣。",
    ],
  },
  {
    id: "news-005",
    title: "角色深度解析：为什么鼬的真相如此令人动容",
    date: "2026-09-20",
    category: "角色分析",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20solemn%20ninja%20standing%20alone%20under%20a%20red%20moon%20with%20falling%20crows%2C%20melancholic%20crimson%20tones%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20emotional%20atmosphere&width=900&height=560&seq=news-005-cover&orientation=landscape",
    summary:
      "从背负骂名到真相揭晓，宇智波鼬的选择为何成为全系列最令人心碎的转折之一。",
    content: [
      "宇智波鼬长期以「灭族凶手」的形象出现，直到真相揭晓，观众才明白他默默背负的一切。他为村子与弟弟牺牲了全部，甚至甘愿被憎恨。",
      "鼬的悲剧在于，他把最深的善意藏进了最冷酷的选择里。正因如此，他的每一次出场都带着难以言说的痛感。",
      "本期角色分析将从他的成长、抉择与最后的告别出发，带读者重新理解这个被误解的英雄。",
    ],
  },
  {
    id: "news-006",
    title: "动画美术风格解析：橙色为何成为作品的灵魂色",
    date: "2026-09-14",
    category: "制作幕后",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20abstract%20scene%20of%20warm%20orange%20and%20red%20color%20swatches%20with%20ninja%20spiral%20motifs%2C%20artistic%20graphic%20composition%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20vibrant%20saturated%20colors&width=900&height=560&seq=news-006-cover&orientation=landscape",
    summary:
      "从主角服装到场景光效，橙色贯穿整部作品的视觉设计，如何一眼传达角色的性格与主题。",
    content: [
      "橙色几乎是《火影忍者》最具辨识度的视觉符号，主角的招牌服装、忍村的夕阳余晖，都反复强化着这种温暖而炽烈的色调。",
      "在色彩心理学中，橙色介于红与黄之间，既热烈又富有活力，恰好呼应了主角永不放弃、渴望被认可的个性。",
      "本期制作幕后将从配色与光影两个角度，带你重新欣赏作品中那些被精心设计过的「橙色瞬间」。",
    ],
  },
  {
    id: "news-007",
    title: "粉丝同人创作征集开启，优秀作品将获官方展示",
    date: "2026-09-06",
    category: "粉丝活动",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20artists%20sketching%20ninja%20characters%20on%20easels%20in%20a%20bright%20studio%2C%20creative%20cheerful%20atmosphere%2C%20warm%20soft%20lighting%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=news-007-cover&orientation=landscape",
    summary:
      "面向全球粉丝的同人创作征集正式开启，涵盖插画与短篇，优秀作品有机会获得官方展示。",
    content: [
      "官方近日宣布面向全球粉丝开启同人创作征集活动，征集类别涵盖插画、短篇漫画等，鼓励粉丝以自己的方式表达对作品的热爱。",
      "活动将邀请专业评审评选出优秀作品，入选者有机会获得官方平台的展示与周边奖励。",
      "动漫频道也欢迎读者分享自己的同人创作心得，共同营造友好而热情的二次元交流氛围。",
    ],
  },
  {
    id: "news-008",
    title: "忍界设定考据：查克拉与忍术体系是如何构建的",
    date: "2026-08-30",
    category: "剧情解析",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20glowing%20abstract%20energy%20swirls%20and%20a%20hand%20seal%20gesture%2C%20mystical%20warm%20orange%20and%20teal%20light%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20mystical%20atmosphere&width=900&height=560&seq=news-008-cover&orientation=landscape",
    summary:
      "查克拉、结印、五遁与血继限界，本文系统梳理作品世界观中的忍术体系与设定逻辑。",
    content: [
      "作品中的忍术体系围绕「查克拉」展开，通过结印将身体能量与精神能量结合，从而释放出各式各样的忍术。",
      "在此基础上，风的五遁属性、血继限界与秘术进一步丰富了战斗的层次，让不同角色拥有了鲜明的能力标识。",
      "本期设定考据将系统梳理这些概念之间的关系，帮助你更清晰地理解忍者世界的内在逻辑。",
    ],
  },
];